import { Header } from '@/components/Header';
import { ManageGroups } from '@/pages/ManageGroups';
import {
  createFileRoute,
  Outlet,
  useRouterState,
} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/_admin/admin/manage-groups'
)({
  component: ManageGroupsPage,
});

function ManageGroupsPage() {
  const router = useRouterState();
  const isChildRoute = router.matches.some(
    (match) =>
      match.routeId === '/_authenticated/_admin/admin/manage-groups/$groupId'
  );

  if (isChildRoute) {
    return <Outlet />;
  }

  return (
    <>
      <Header enableBack additionalClasses="bg-slate-700" />
      <ManageGroups />
    </>
  );
}
